const uk_UA = {
    homepage_title: 'Завантажити CalendarTask мобільну версію за QR-кодом',
    homepage_slogn: 'CalendarTask мобільна версія',
    homepage_ios_download: 'App Store на перевірці...',
    homepage_download: 'Завантажити',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'Завантажити CalendarTask мобільну версію за QR-кодом',
    phonedownload_slogan: 'Синхронізація з ПК та планшетом, нотатки скрізь',
    phonedownload_send_vip: 'Встановіть додаток та отримайте VIP-підписку',
    phonedownload_screenshot: 'Знімок екрана',
    phodedownload_macos: 'CalendarTask версія macOS',
    phodedownload_windows: 'CalendarTask версія Windows',
    phodedownload_otherbutton: 'Переглянути зараз',
    phodedownload_about: 'Контакт',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Без реклами',
    feature_easy: 'Місячний вигляд, простий та зручний',
    feature_reminder: 'Користувацьке нагадування',
    feature_countdown: 'Зворотний відлік річниці',

    vip_task_succ: 'Успіх. Завантажте додаток для активації VIP',
    vip_task_error: 'Отримання не вдалося',

    group_slogn: 'Запрошення CalendarTask команда',

    tt_title: 'CalendarTask',
    tt_share_1: 'Поділилися з вами',
    tt_share_2: 'Розклад',
    tt_share_show_1: 'Відскануйте QR-код додатком "CalendarTask", ПК та телефон покажуть',
    tt_share_show_2: 'розклад',
    tt_share_scan_1: 'Сканувати',
    tt_share_scan_2: 'додатком "CalendarTask"',
    tt_share_succ: 'Синхронізація успішна',

    v2_copyright: 'Контакт service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Усі права захищені.',
    v2_download_appstore: 'Завантажити в App Store',
    v2_download_googleplay: 'Доступно в Google Play',

    v2_main_title: 'CalendarTask Мобільний',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Мобільний',
    v2_main_description: 'Знайдіть <span class="name">CalendarTask</span> в App Store або Google Play',
    v2_download_ios: 'Завантажити iOS',
    v2_download_android: 'Завантажити Android',
    v2_download_harmonyos: 'Завантажити HarmonyOS',
    v2_sync_status: 'Синхронізація завершена! 1 завантажено, 0 завантажено',
    v2_feature_title: 'Синхронізація даних кількох пристроїв',
    v2_feature_description: 'Синхронізація між телефоном, планшетом та ПК'
};
export default uk_UA;
